/**
 * Calculate stars for a completed puzzle (move-based, not time-based).
 * - 3 stars: no undo AND moves ≤ par (2× emitter count)
 * - 2 stars: 1-2 undos, or over par moves
 * - 1 star: 3+ undos
 */
export function calculateStars(
  moves: number,
  emitterCount: number,
  undoCount: number,
): number {
  if (undoCount >= 3) return 1;
  const parMoves = emitterCount * 2;
  if (undoCount > 0 || moves > parMoves) return 2;
  return 3;
}
